import { useMutation, useQueryCache } from "react-query";
import { useToasts } from "react-toast-notifications";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { unlinkNotifySubscriberContactMethodToPerson } from "../../../queries/notify";
import { ToastStatuses } from "../../../components/global_components/Toast";
import { buildNotifyContactsQueryKey } from "./useInfiniteNotifyContacts";
import { buildNotifyContactQueryKey } from "./useNotifyContact";

export function useNotifySubscriberContactMethodDisconnect() {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();
  const { addToast } = useToasts();

  const [unlinkSubscriberContactMethodMutation, { isLoading: isUnlinkNotifySubscriberContactMethodToPersonMutation }] =
    useMutation(unlinkNotifySubscriberContactMethodToPerson(networkHeaders), {
      onSuccess: async (_, variables) => {
        await queryCache.invalidateQueries(buildNotifyContactsQueryKey());
        await queryCache.invalidateQueries(buildNotifyContactQueryKey({ id: variables.id }));
      },
      onError: () => {
        addToast("Failed to disconnect subscriber Contact from userId", {
          appearance: ToastStatuses.Error,
          autoDismiss: true,
        });
      },
    });

  const unlinkSubscriberContactMethod = async (id: number) => {
    return await unlinkSubscriberContactMethodMutation({ id });
  };

  return {
    unlinkSubscriberContactMethod,
    isUnlinkNotifySubscriberContactMethodToPersonMutation,
  };
}
